import React, { Fragment, useEffect, useState } from "react";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Select as AntSelect } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { dateParserWithoutTime } from "../../helper";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getExternalAuditByID } from "../../services/verificationService";
import FileAttachmentsDetails from "../common/FileAttachmentsDetails";
import AuditVersionHistory from "./AuditVersionHistory";

const AuditDetailedView = (props: any) => {
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const { t, i18n } = useTranslation();

  const {
    selectedAuditId,
    statusOptions,
    onClose,
    controller,
    total_count,
    currentIndex,
    navigateNext,
    handleStatusChange,
  } = props;

  const { Option } = AntSelect;
  const { page, limit } = controller;
  let index = limit * page + currentIndex;
  let facilitiesCellColumns = ["Name", "Incharge", "Type"];

  const [auditData, setAuditData] = useState({} as any);
  const [attachmentsData, setAttachmentsData] = useState({
    attachments: [],
  } as any);

  useEffect(() => {
    if (selectedAuditId) {
      getExternalAuditByID(selectedAuditId).then((res) => {
        if (res?.data) {
          setAuditData(res.data);
          let attachments: any[] = [];
          if (res?.data?.auditRequest?.attachments?.files?.length) {
            attachments = res.data.auditRequest.attachments.files;
          }
          setAttachmentsData({
            attachments,
          });
        }
      });
    }
  }, [selectedAuditId]);

  return (
    <div className="flex w-70 flex-col px-4 grow pw-detailed-view-main">
      <div className="flex flex-row items-center pw-justify-space-between gap-6 p-2 px-4">
        <div className="flex flex-row items-start pw-justify-space-between gap-6"></div>
        <div className="pw-bunit-detailed-header flex justify-end gap-3 pr-2">
          {/* {checkPermissions(["CREATE_OFFSET"], permissions) ? (
            <Button className="pw-editbox-emission">
              <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
              <div className="pw-edit">{t("Edit")}</div>
            </Button>
          ) : (
            ""
          )} */}

          {index > 0 && (
            <div
              // onClick={() => onNavigateNext(-1)}
              className="pw-navigate-next pw-padding-5"
            >
              <img src="assets/icons/prev.svg" alt=" " />
            </div>
          )}
          {index < total_count - 1 && (
            <div
              // onClick={() => onNavigateNext(1)}
              className="pw-navigate-next pw-padding-5 pw-bunit-next"
            >
              <img src="assets/icons/next.svg" alt=" " />
            </div>
          )}

          <div
            onClick={() => onClose()}
            className="pw-navigate-next items-center"
          >
            <CloseIcon className=" items-center text-neutral-600" />
          </div>
        </div>
      </div>

      <Fragment>
        <div className="w-full p-6 my-4 bg-white rounded-lg shadow flex-col justify-start items-start gap-6 inline-flex">
          <div className="self-stretch justify-start items-start gap-2 inline-flex">
            <div className="flex-col justify-start items-start gap-6 inline-flex">
              <div className="flex-col justify-start items-start gap-6 flex">
                <div className="flex flex-row gap-6">
                  <div className="w-48 text-slate-500 text-sm font-normal">
                    {t("Verifying company")}:
                  </div>
                  <div
                    className="text-neutral-800 text-sm"
                    id="pw-e2e-dv-assetid"
                  >
                    {auditData?.auditRequest?.auditor_company
                      ? auditData.auditRequest.auditor_company
                      : "-"}
                  </div>
                </div>
                <div className="flex flex-row gap-6">
                  <div className="w-48 text-slate-500 text-sm font-normal">
                    {t("Email")}:
                  </div>
                  <div
                    className="text-neutral-800 text-sm"
                    id="pw-e2e-dv-assetype"
                  >
                    {auditData?.auditRequest?.email
                      ? auditData.auditRequest.email
                      : "-"}
                  </div>
                </div>
                <div className="flex flex-row gap-6">
                  <div className="w-48 text-slate-500 text-sm font-normal">
                    {t("Reporting period")}:
                  </div>
                  <div
                    className="text-neutral-800 text-sm font-normal"
                    id="pw-e2e-dv-assetname"
                  >
                    {dateParserWithoutTime(auditData?.auditRequest?.from_date) +
                      " - " +
                      dateParserWithoutTime(auditData?.auditRequest?.to_date)}
                  </div>
                </div>
                <div className="flex flex-row gap-6">
                  <div className="w-48 text-slate-500 text-sm font-normal">
                    {t("Status")}:
                  </div>
                  {auditData?.auditRequest?.status ? (
                    <div>
                      {auditData.auditRequest.status === "Requested" ||
                      auditData.auditRequest.status === "In Progress" ? (
                        <AntSelect
                          placeholder="Please select"
                          dropdownStyle={{
                            minWidth: "12rem",
                            paddingRight: "12px",
                          }}
                          suffixIcon={
                            <CaretDownOutlined className="!pointer-events-none" />
                          }
                          value={auditData.auditRequest.status}
                          className={`pw-offset-status-selection pw-${auditData.auditRequest.status.toLowerCase()}`}
                          onChange={(event: any) => {
                            handleStatusChange(
                              event,
                              auditData.auditRequest,
                              index,
                              false
                            );
                          }}
                        >
                          {statusOptions[auditData.auditRequest.status]?.map(
                            (name: any, index: number) => {
                              return (
                                <Option
                                  value={name}
                                  className={` pw-margin-10 font-bold pw-${name.toLowerCase()}`}
                                >
                                  {name}
                                </Option>
                              );
                            }
                          )}
                        </AntSelect>
                      ) : (
                        <div
                          className={`pw-${auditData.auditRequest.status.toLowerCase()} pw-offset-status-list`}
                        >
                          {auditData.auditRequest.status}
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {auditData?.businessUnits?.length ? (
          <div className="w-full p-6 my-4 bg-white rounded-lg shadow flex-col justify-start items-start gap-6 inline-flex">
            <div className="self-stretch text-slate-400 text-xs font-bold uppercase">
              {t("FACILITIES")}
            </div>
            <Table
              size="small"
              className="pw-bunit-table pw-emission-table-container mb-5"
            >
              <TableHead className="pw-blist-head bg-neutral-50">
                <TableRow className="h-14">
                  {facilitiesCellColumns.map((eachCell, index) => (
                    <TableCell
                      key={index}
                      className={`pw-thead-list ${
                        eachCell === "Status" ? "text-" : ""
                      }`}
                    >
                      {eachCell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {auditData.businessUnits?.map(
                  (eachBUnit: any, index: number) => (
                    <TableRow
                      key={eachBUnit.association_id}
                      className={` ${
                        eachBUnit.selected ? "bg-primary-100" : "bg-white"
                      } h-14`}
                    >
                      <TableCell className="pw-e2e-dv-facility-name">
                        {eachBUnit.name || "-"}
                      </TableCell>
                      <TableCell>{eachBUnit.incharge_name || "-"}</TableCell>
                      <TableCell>{eachBUnit.type_name || "-"}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </div>
        ) : (
          ""
        )}
        {attachmentsData?.attachments?.length ? (
          <div className="w-full p-6 my-4 bg-white rounded-lg shadow flex-col justify-start items-start gap-6 inline-flex">
            <div className="self-stretch text-slate-400 text-xs font-bold uppercase">
              {t("CERTIFICATES")}
            </div>
            <div className="self-stretch justify-start items-start gap-2 inline-flex">
              <div className="flex-col justify-start items-start gap-6 inline-flex">
                <FileAttachmentsDetails
                  formData={attachmentsData}
                  fromEmissionDetail={true}
                  hideAttachmentsHeader={true}
                ></FileAttachmentsDetails>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {auditData?.auditRequestTransactions?.length ? (
          <AuditVersionHistory
            versionHistoryData={auditData.auditRequestTransactions}
          ></AuditVersionHistory>
        ) : (
          ""
        )}
      </Fragment>
    </div>
  );
};

export default AuditDetailedView;
